import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import Footer from './Footer';
import CaptivateConfig from './CaptivateConfig';

import './index.css';

let config = new CaptivateConfig();

ReactDOM.render(
  <App logo={config.logo} colorClass={config.colorClass} />,
  document.getElementById('root')
);

ReactDOM.render(
	<Footer bgColor={config.colorClass + '-bg'} />,
	document.getElementById('footer')
);



// WEBPACK FOOTER //
// ./src/index.js